import { HOURLY, MONTHLY, ANNUAL } from '@/lib/constants/payRateTypes'
import { getNetBillRate } from './billRateCalculator'

export function getTotalPayRate (overheadPercent, payRate) {
  return payRate + (payRate * (overheadPercent / 100))
}

export function convertPayRate (payRate, currentPayRateType, desiredPayRateType, workedHoursAverage) {
  switch (desiredPayRateType) {
    case HOURLY:
      return getHourlyPayRate(payRate, currentPayRateType, workedHoursAverage)
    case MONTHLY:
      return getMonthlyPayRate(payRate, currentPayRateType, workedHoursAverage)
    case ANNUAL:
      return getAnnualPayRate(payRate, currentPayRateType, workedHoursAverage)
  }
}

export function getHourlyPayRate (payRate, payRateType, workedHoursAverage) {
  switch (payRateType) {
    case HOURLY:
      return payRate
    case MONTHLY:
      return payRate / workedHoursAverage
    case ANNUAL:
      return (payRate / 12) / workedHoursAverage
  }
}

export function getMonthlyPayRate (payRate, payRateType, workedHoursAverage) {
  switch (payRateType) {
    case HOURLY:
      return payRate * workedHoursAverage
    case MONTHLY:
      return payRate
    case ANNUAL:
      return payRate / 12
  }
}
export function getAnnualPayRate (payRate, payRateType, workedHoursAverage) {
  switch (payRateType) {
    case HOURLY:
      return (payRate * workedHoursAverage) * 12
    case MONTHLY:
      return payRate * 12
    case ANNUAL:
      return payRate
  }
}

export function getHourlyTotalPayRate (overheadPercent, payRate, payRateType, workedHoursAverage) {
  return getTotalPayRate(overheadPercent, getHourlyPayRate(payRate, payRateType, workedHoursAverage))
}

export function getMonthlyTotalPayRate (overheadPercent, payRate, payRateType, workedHoursAverage) {
  return getTotalPayRate(overheadPercent, getMonthlyPayRate(payRate, payRateType, workedHoursAverage))
}

export function getAnnualTotalPayRate (overheadPercent, payRate, payRateType, workedHoursAverage) {
  return getTotalPayRate(overheadPercent, getAnnualPayRate(payRate, payRateType, workedHoursAverage))
}

export function calculatePayRate (grossProfit, billRate, overheadPercent, vmsFee) {
  return (getNetBillRate(vmsFee, billRate) - grossProfit) / (1 + (overheadPercent) / 100)
}
